import { create } from "zustand";

import {
  createIterationSlice,
  type IterationSlice,
} from "./search/iterationSlice";
import { createReviewSlice, type ReviewSlice } from "./search/reviewSlice";
import { createSessionSlice, type SessionSlice } from "./search/sessionSlice";
import { createUiSlice, type UiSlice } from "./search/uiSlice";

export type SearchStore = SessionSlice & IterationSlice & ReviewSlice & UiSlice;

// Everything the Laborup Search experience keeps between renders and across
// tab switches (the search tab unmounts on every in-app navigation):
//   session   — the live/paused guac session, its clock and counters
//   iteration — the current pass over one result set inside the session
//   review    — search results held for the review queue's highlights (per job,
//               outlives the session: the queue itself is server state)
//   ui        — review modal open state and filters-dialog open requests
// Session `resetSession` clears session + iteration. Side effects (HTTP,
// listeners, timers) live in useSearchSession.
export const searchStore = create<SearchStore>()((...args) => ({
  ...createSessionSlice(...args),
  ...createIterationSlice(...args),
  ...createReviewSlice(...args),
  ...createUiSlice(...args),
}));
